import { lazy } from "react";
import { Navigate } from "react-router";
import Loadable from "src/routes/Loadable";

const Ewallet = Loadable(
  lazy(() => import("src/pages/admin/financial/ewallet")),
);
const RoiWallet = Loadable(
  lazy(() => import("src/pages/admin/financial/roi-wallet")),
);
const FundTransfer = Loadable(
  lazy(() => import("src/pages/admin/financial/fund-transfer")),
);
const DepositWallet = Loadable(
  lazy(() => import("src/pages/admin/financial/deposit")),
);
const FundCredits = Loadable(
  lazy(() => import("src/pages/admin/financial/fundCredit/index")),
);
const Payout = Loadable(
  lazy(() => import("src/pages/admin/financial/payout/index")),
);
const PayoutRequest = Loadable(
  lazy(() =>
    import("src/pages/admin/financial/payout/components/request/index"),
  ),
);
const PayoutHistory = Loadable(
  lazy(() =>
    import("src/pages/admin/financial/payout/components/history/index"),
  ),
);
const FinancialReport = Loadable(
  lazy(() =>
    import("src/pages/admin/financial/financialReport/financialReport"),
  ),
);

const LatestSales = Loadable(
  lazy(() => import("src/pages/admin/financial/sales/index")),
);
const Loan = Loadable(
  lazy(() => import("src/pages/admin/financial/loan-request/index")),
);
const LoanRequest = Loadable(
  lazy(() => import("src/pages/admin/financial/loan-request/request/index")),
);
const LoanHistory = Loadable(
  lazy(() => import("src/pages/admin/financial/loan-request/history/index")),
);
const Repayment = Loadable(
  lazy(() => import("src/pages/admin/financial/repayment/index")),
);
const RepaymentRequest = Loadable(
  lazy(() => import("src/pages/admin/financial/repayment/request/index")),
);
const RepaymentHistory = Loadable(
  lazy(() => import("src/pages/admin/financial/repayment/history/index")),
);

const financial = [
  {
    path: "financial",
    children: [
      { element: <Navigate to="e-wallet" />, index: true },
      { path: "e-wallet", element: <Ewallet /> },
      { path: "roi-wallet", element: <RoiWallet /> },
      { path: "deposit-wallet", element: <DepositWallet /> },
      { path: "fund-credits", element: <FundCredits /> },
      {
        path: "payout",
        element: <Payout />,
        children: [
          { index: true, element: <Navigate to="request" replace /> },
          { path: "request", element: <PayoutRequest /> },
          { path: "history", element: <PayoutHistory /> },
        ],
      },
      {
        path: "loan",
        element: <Loan />,
        children: [
          { index: true, element: <Navigate to="request" replace /> },
          { path: "request", element: <LoanRequest /> },
          { path: "history", element: <LoanHistory /> },
        ],
      },
      {
        path: "repayment",
        element: <Repayment />,
        children: [
          { index: true, element: <Navigate to="request" replace /> },
          { path: "request", element: <RepaymentRequest /> },
          { path: "history", element: <RepaymentHistory /> },
        ],
      },
      { path: "report", element: <FinancialReport /> },
      { path: "sales", element: <LatestSales /> },
      { path: "fund-transfer", element: <FundTransfer /> },
    ],
  },
];

export default financial;
